import * as React from 'react';
import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';
import * as Cookie from 'js-cookie';

import { useConfig } from '@websky/core/src/context';
import { ModalX } from '@websky/core';

const LEAVE_PAGE_MODAL_SHOWN = 'LEAVE_PAGE_MODAL_SHOWN';
const RESULTS_REGEX = /results\/\d+/;

const LeavePageModal: React.FC = () => {
	const location = useLocation();

	const updateIdRef = useRef(0);
	const hasLeftRef = useRef(false);

	const timerRef = useRef<NodeJS.Timer>();

	const {
		global: { showLeavePageModal }
	} = useConfig();

	const isResultsPage = RESULTS_REGEX.test(location.pathname);
	const isShowLeavePageModal = showLeavePageModal && isResultsPage;

	const [isOpen, setIsOpen] = useState(false);

	useEffect(() => {
		const onMouseMove = () => {
			if (hasLeftRef.current) {
				clearTimeout(timerRef.current);
				hasLeftRef.current = false;
			}
		};

		const onMouseOut = (e: MouseEvent) => {
			const relatedTarget = e.relatedTarget as HTMLElement;

			if (!relatedTarget || relatedTarget.nodeName === 'HTML') {
				timerRef.current = setTimeout(() => setIsOpen(true), 500);
				hasLeftRef.current = true;
			}
		};

		if (isShowLeavePageModal && Cookie.get(LEAVE_PAGE_MODAL_SHOWN) !== 'true') {
			document.addEventListener('mousemove', onMouseMove);
			document.addEventListener('mouseout', onMouseOut);
		}

		return () => {
			document.removeEventListener('mousemove', onMouseMove);
			document.removeEventListener('mouseout', onMouseOut);
		};
	}, [updateIdRef.current, isShowLeavePageModal]);

	const onClose = () => {
		Cookie.set(LEAVE_PAGE_MODAL_SHOWN, 'true', { expires: 1 });
		setIsOpen(false);

		updateIdRef.current++;
	};

	return (
		<ModalX size="medium" isOpen={isOpen} onClose={onClose}>
			<iframe
				src="https://forms.yandex.ru/cloud/67ab65d184227cfd06f381fb/?iframe=1"
				name="ya-form-67ab65d184227cfd06f381fb"
				frameBorder={0}
				width="100%"
				height="500px"
			/>
		</ModalX>
	);
};

export default LeavePageModal;
